import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import { Button } from "@mui/material";
import instance from "../../../utilities/Instance";

export function ModalsubCreator (props) {
    const { handleClose, setLoader, setDataResponse, setCatchResponse, basePath, getFields, requiredProperties} = props
    const [datos, setDatos] = useState({})


    const handleChange = (e)=>{
        if (e) {
            if (Array.isArray(e)){
                let data = datos;

                for(const target of e){
                    data = {...data, [target.name]: target.value};
                }

                setDatos(data);
            }
            else {
                setDatos({ ...datos, [e.target.name]:e.target.value })
            }
        }
    }

    const getDataSearch=async (cuerpo)=>{
        setLoader(true)
        const data = {
            ...datos
        }
        await instance.postForm(basePath+"/"+cuerpo, data)
            .then(async(response)=>{
                if(response?.data?.data){
                    setDataResponse(response.data.data)}
                handleClose(response.data.data);
            }).catch(error =>{
                if(error?.response?.data){
                    setCatchResponse(error.response.data)}
            })
        setLoader(false)
    }


    useEffect(()=>{
    },[datos])


    return(
        <React.Fragment>
            <Grid container spacing={2} padding={2} >
                {getFields(datos, handleChange)}
            </Grid>

            <Grid container spacing={3}>

                <Grid item xs={12} md={6} lg={6}>
                    <Button onClick={()=>handleClose()}>Cancelar</Button>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <Button onClick={()=>handleClose(datos)}>Agregar</Button>
                </Grid>
            </Grid>

        </React.Fragment>
    )
}